import { gql } from '@apollo/client';

export * from './integrations.query.generated';

export const INTEGRATIONS = gql`
  query integrations(
    $page: Int
    $perPage: Int
    $type: IntegrationTypeEnum
    $query: String
    $provider: IntegrationProviderEnum
    $status: IntegrationStatusEnum
    $active: Boolean
  ) {
    integrations(
      page: $page
      perPage: $perPage
      type: $type
      query: $query
      provider: $provider
      status: $status
      active: $active
    ) {
      hasNextPage
      hasPreviousPage
      nodes {
        active
        accountName
        membersCount
        id
        accountUrl
        provider
        status
        tenantId
        __typename
        owner {
          name
          email
        }
        policy {
          update
          read
        }
      }
      nodesCount
      pagesCount
    }
  }
`;
